import React from 'react';
import PropTypes from 'prop-types';

import * as AppPropTypes from '../../lib/PropTypes';
import { getComponentFromName } from '../../lib/utils';
import * as CustomCards from './index-custom';

const propTypes = {
    item: AppPropTypes.card.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const Custom = ({ item, className }) => {
    const { handle = null } = item || {};
    const CustomCardComponent = getComponentFromName(CustomCards, handle, 'default');
    return CustomCardComponent !== null ? (
        <CustomCardComponent item={item} className={className} />
    ) : null;
};

Custom.propTypes = propTypes;
Custom.defaultProps = defaultProps;

export default Custom;
